<div class="forgot-page">
  <div class="forgot-card">
    <div class="forgot-card__icon" aria-hidden="true">
      <mat-icon>lock_reset</mat-icon>
    </div>

    <h1 class="forgot-card__title">Mot de passe oublié</h1>
    <p class="forgot-card__subtitle" *ngIf="currentStep === 0">
      Renseignez votre numéro de téléphone et votre nouveau mot de passe. Un code de validation vous sera envoyé par SMS.
    </p>
    <p class="forgot-card__subtitle" *ngIf="currentStep === 1">
      Saisissez le code à 6 chiffres envoyé au
      <strong>{{ otpPhoneDisplay }}</strong>.
    </p>

    <form class="forgot-form" [formGroup]="form" (ngSubmit)="submit()" novalidate>
      <ng-container *ngIf="currentStep === 0">
        <div class="field-group">
          <app-phone-input
            #phoneInput
            formControlName="phone"
            inputId="forgot-phone"
            [invalid]="form.controls.phone.touched && form.controls.phone.invalid" />
          <span class="field-error" *ngIf="getPhoneError() as phoneError">{{ phoneError }}</span>
        </div>

        <p class="forgot-hint">{{ passwordHint }}</p>

        <div class="field-group">
          <div class="field field--password" [class.field--invalid]="form.controls.password.touched && form.controls.password.invalid">
            <mat-icon class="field__icon" aria-hidden="true">lock</mat-icon>
            <input
              class="field__input"
              [type]="hidePassword ? 'password' : 'text'"
              formControlName="password"
              placeholder="Nouveau mot de passe"
              autocomplete="new-password" />
            <button class="field__toggle" type="button" (click)="hidePassword = !hidePassword">
              <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </div>
        </div>

        <div class="field-group">
          <div
            class="field field--password"
            [class.field--invalid]="form.controls.confirmPassword.touched && form.controls.confirmPassword.invalid">
            <mat-icon class="field__icon" aria-hidden="true">lock</mat-icon>
            <input
              class="field__input"
              [type]="hideConfirmPassword ? 'password' : 'text'"
              formControlName="confirmPassword"
              placeholder="Confirmer le mot de passe"
              autocomplete="new-password" />
            <button class="field__toggle" type="button" (click)="hideConfirmPassword = !hideConfirmPassword">
              <mat-icon>{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </div>
          <span class="field-error" *ngIf="form.controls.confirmPassword.touched && form.controls.confirmPassword.hasError('passwordMismatch')">
            Les mots de passe ne correspondent pas
          </span>
        </div>
      </ng-container>

      <ng-container *ngIf="currentStep === 1">
        <div class="field-group">
          <div class="field field--otp" [class.field--invalid]="form.controls.otp.touched && form.controls.otp.invalid">
            <input
              class="field__input field__input--otp"
              type="text"
              formControlName="otp"
              placeholder="000000"
              inputmode="numeric"
              maxlength="6"
              autocomplete="one-time-code" />
          </div>
        </div>

        <button
          class="forgot-link-btn"
          type="button"
          [disabled]="otpResendSeconds > 0 || loading"
          (click)="resendOtp()">
          {{ otpResendSeconds > 0 ? 'Renvoyer dans ' + otpResendSeconds + 's' : 'Renvoyer le code' }}
        </button>
      </ng-container>

      <p class="forgot-error" *ngIf="errorMessage" role="alert">{{ errorMessage }}</p>
      <p class="forgot-success" *ngIf="successMessage" role="status">{{ successMessage }}</p>

      <div class="forgot-actions">
        <button class="forgot-btn forgot-btn--secondary" type="button" *ngIf="currentStep === 1" (click)="previousStep()">
          Retour
        </button>
        <button class="forgot-btn forgot-btn--primary" type="submit" [disabled]="loading">
          {{
            loading
              ? 'Traitement…'
              : currentStep === 0
                ? 'Recevoir le code OTP'
                : 'Valider le nouveau mot de passe'
          }}
        </button>
      </div>
    </form>

    <div class="forgot-login">
      <a routerLink="/se-connecter">Retour à la connexion</a>
    </div>
  </div>
</div>
